const urlConcatenator = (url, array, array2) =>
  `${url}?${array
    .map(
      (value, index) =>
        `key[${index}]=${value}&group[${index}]=${array2[index]}`
    )
    .join('&')}`;

export default urlConcatenator;
